import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class FourEyesAdminPanelService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'FourEyesAdminPanelService');
  }

  update(params: any): Observable<any> {
    const serviceUrl = `${this.baseUrl}FourEyesAdminPanelService/update`;
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  getRoles(): Observable<any> {
    const serviceUrl = `${this.baseUrl}FourEyesAdminPanelService/roles`;
    return this.request(serviceUrl).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
}
